"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPubKeys = exports.toPubKey = void 0;
const anchor_1 = require("@project-serum/anchor");
function toPubKey(address) {
    return (0, anchor_1.translateAddress)(address);
}
exports.toPubKey = toPubKey;
function toPubKeys(addresses) {
    return addresses.map((address) => toPubKey(address));
}
exports.toPubKeys = toPubKeys;
